import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';
import { Goal } from '@models/performance/goal.model';
import { Review } from '@models/performance/review.model';
import { Survey } from '@models/performance/survey.model';
import { Feedback } from '@models/performance/feedback.model';
import { Template } from '@models/performance/template.model';

@Injectable()
export class PerformanceResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'goal',
            production: {
                find: (id: number) => {
                    return Goal.with([
                        'assignments',
                        'assignments.employee',
                        'updates',
                        'updates.employee',
                        'creator',
                        'status',
                        'participants',
                    ]).find(id);
                },
            },
        },
        {
            className: 'review',
            production: {
                find: (id: number) => {
                    // the client will ask for all of these related entities
                    // but the server will only return those that this
                    // user should be allowed to access
                    return Review.with([
                        'template',
                        'assignments',
                        'assignments.employee',
                        'assignments.response',
                        'responses',
                        'responses.employee',
                        'creator',
                        'status',
                        'subject',
                        'participants',
                        'userResponse',
                    ]).find(id);
                },
            },
        },
        {
            className: 'survey',
            production: {
                find: (id: number) => {
                    // the client will ask for all of these related entities
                    // but the server will only return those that this
                    // user should be allowed to access
                    return Survey.with([
                        'template',
                        'assignments',
                        'assignments.employee',
                        'assignments.response',
                        'responses',
                        'responses.employee',
                        'creator',
                        'status',
                        'participants',
                        'userResponse',
                    ]).find(id);
                },
            },
        },
        {
            className: 'feedback',
            production: {
                find: (id: number) => {
                    return Feedback.param('company', this.companyId).with(['creator', 'subject']).find(id);
                },
            },
        },
        {
            className: 'template',
            production: {
                find: (id: number) => {
                    return Template.find(id);
                },
            },
        },
    ]);
}
